import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

//import theme from '@ecp/common/src/style/theme/default';
import { useTheme } from 'styled-components';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { FlexBoxColumn, FlexBoxSpaceBetween, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import ChipSearch from '@ecp/common/src/components/chip/ChipSearch';
import Swiper from '@ecp/common/src/components/swiper/Swiper';

const SwiperItem = ({ item, itemProps }) => {
  const theme = useTheme();
  return (
    <ChipSearch
      style={{ maxWidth: '138px' }}
      font-size={theme.font.size.$13}
      type={'button'}
      closable={false}
      onClick={itemProps.onClick}
    >
      {item}
    </ChipSearch>
  );
};

SwiperItem.propTypes = {
  item: PropTypes.shape({
    keyword: PropTypes.string,
  }),
  itemProps: PropTypes.object,
};

const RecommendKeyword = ({ recommendKeywordList, handleSearch }) => (
  <Wrapper data-ds-label2={'q_reco_search'} >
    <Spacing top={20} />
    <FlexBoxSpaceBetween width={'100%'}>
      <SearchKeyword>추천 검색어</SearchKeyword>
    </FlexBoxSpaceBetween>
    <Spacing top={20} />
      <Swiper
        width={'380px'}
        arrowProps={{ type: '4' }}
        itemList={recommendKeywordList}
        itemProps={{ width: 'auto', onClick: handleSearch }}
        itemComponent={SwiperItem}
        carouselProps={{ slidesPerView: 'auto', loop: false, spaceBetween: 5 }}
      />
    <Spacing top={9} />
    <HorizontalDivider />
  </Wrapper>
);

const Wrapper = styled(FlexBoxColumn)`
  width: 100%;
  height: 105px;
`;

RecommendKeyword.propTypes = {
  recommendKeywordList: PropTypes.array,
  handleSearch: PropTypes.func,
};

const SearchKeyword = styled(TextBox)`
  font-size: ${(props) => props.theme.font.size.title};
  font-weight: ${(props) => props.theme.font.weight.bold};
  width: 87px;
  height: 22px;
  white-space: nowrap;
`;

export default RecommendKeyword;
